import { ProjectRunConfigurationType } from "@app/projects/enumerators";
import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";

/**
 * Membership type for the map data-header chips and the map export banners, or null when the run
 * wasn't a dual-membership run. The alias is the run configuration's creation-time snapshot, so it
 * reports the membership the run was built with rather than a later rename. The backend pre-fills
 * it with "Primary Membership"/"Secondary Membership" when no alias was configured, so the fallback
 * below only covers anomalous data.
 */
export function getMembershipTypeLabel(
  runConfiguration: ProjectRunConfiguration | null | undefined,
): string | null {
  const isPrimary = runConfiguration?.projectRunConfigurationType === ProjectRunConfigurationType.DualMembershipPrimary;
  const isSecondary = runConfiguration?.projectRunConfigurationType === ProjectRunConfigurationType.DualMembershipSupplemental;

  if (!isPrimary && !isSecondary) {
    return null;
  }

  const alias = runConfiguration?.memberSetAlias?.trim();

  if (!alias) {
    return isSecondary ? "Secondary Membership" : "Primary Membership";
  }

  return alias;
}
